export const addFavoriteLabel = "VmRKsd";
export const hideFavoritesLabel = "bD18Gd";
export const newFavoritePickedText = "z4Grzc";
export const renameFavoriteLabel = "qpB7De";
export const pinFavoritesLabel = "YW_Gpd";
export const unpinFavoritesLabel = "tzAKh";
export default {addFavoriteLabel,hideFavoritesLabel,newFavoritePickedText,renameFavoriteLabel,pinFavoritesLabel,unpinFavoritesLabel};